import React, {Component} from "react";
import {connect} from "react-redux";
import SockJS from "sockjs-client"; //^1.3.0
import Stomp from "stompjs"; //^2.3.3
import Mp3 from "./components/mp3/notification.mp3";
//components & style
import Container from "./Container";
import Locale from './components/locale';
import MessengerOptions from "./components/MessengerOptions";
import ChatMainIcon from "./components/chatMainIcon";
import "./index.css";
//actions
import {
    onToggleWidget,
    onGetEventFeedback,
    onMessage,
    onAddMark,
    onMenuReceiver,
    onMenuReceiverHide,
    onBackupHistoryMessages,
    onSend,
} from "./redux/actions"

var clientID = '';
var clientName = '';
var clientSurname = '';
var clientPhone = '';
var lng = '';

class App extends Component {
    state = {
        addMark: false,
        visibleChat: false,
        openingChat: false,
        visibleDropZone: false,
        previewFile: false,
        previewFileName: false,
        onVisiblePreviewFile: false,
        visibleEmojiBlock: false,
        fontSize: 'fs-medium',
        visibleCounterNewMessage: false,
        muteNotification: true,
        countMess: 0,
        heightMenu: '',
        oldCounterHistoryMessage: 0,
        autoplayMainIcon: true,
        isConnected: false,
        sessionParentComponent: null,
        mobilePhone: false,
        largeTabletDevice: null,
        roomExpired: false,
        roomExpiredSendingLastMessage: false,
        visibleWebChat: 'true',
        sendParamsAfterFinishConversation: false,
    };

    connected = false;
    socket = null;
    notSupportedBrowser = null;

    componentDidMount() {
        const webChatMutationAttr = document.getElementById('webChatMutationAttr');
        if (webChatMutationAttr && webChatMutationAttr.getAttribute('data-visible-attr') === 'false') {
            this.handlerChangeVisibleWebChat('false')
        }
        let ua = window.navigator.userAgent;
        let msie = ua.indexOf("MSIE ");

        if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./) || !!navigator.userAgent.match(/Trident.*rv\:10\./) || !!navigator.userAgent.match(/Trident.*rv\:9\./)) {
            this.notSupportedBrowser = true;
        }

        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent)) {
            this.setState({mobilePhone: true});
        }

        this.whatWidthUserDevise();
    }

    whatWidthUserDevise = () => {
        let windowWidth = window.innerWidth;

        if (windowWidth > 1199) {
            this.setState({largeTabletDevice: true})
        }
    };

    handlerUpdateCounterHistoryMessage = (roomExpired) => {
        let lastElementOfHistoryData = this.props.history.data && this.props.history.data.slice(-1);
        if (lastElementOfHistoryData && lastElementOfHistoryData[0] && lastElementOfHistoryData[0].receiver && lastElementOfHistoryData[0].receiver.type === "KEYBOARD") {
            this.props.onMenuReceiver(lastElementOfHistoryData[0].receiver);
        }

        this.setState({countMess: this.props.history.data ? this.props.history.data.length : 0}, () => {
            if (roomExpired) {
                this.handlerOnBackupHistoryMessage()
            }
        });
    };

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.config.eventFeedback === 'TYPING') {
            let timerId = setInterval(function () {
            }, 1500);
            setTimeout(function () {
                nextProps.onGetEventFeedback("");
                clearInterval(timerId);
            }, 4000);
        }

        if (nextState.openingChat === false && this.props.history.data && this.props.history.data.length !== 0 && this.props.history.data.length !== nextProps.history.data.length) {
            this.setState({
                visibleCounterNewMessage: true,
                oldCounterHistoryMessage: nextProps.history.data.length - nextState.countMess
            });
            return true
        }

        if (this.props.history.data && this.props.history.data.length !== 0 && this.props.history.data.length !== nextProps.history.data.length) {
            this.setState({
                addMark: true,
            });
        }
        return true;
    }

    handlerChangeRoomExpired = roomExpired => this.setState({roomExpired});

    changeAddMark = mark => this.setState({addMark: mark});

    handleChangeHeightWithMenu = heightMenu => this.setState({heightMenu});

    handleVisibleChat = parameter => this.setState({
        visibleChat: parameter,
        openingChat: false,
        autoplayMainIcon: true,
        countMess: this.props.history.data && this.props.history.data.length
    }, () => {
        let isOpenChat = document.getElementById('open_webchat');
        let attr = isOpenChat.getAttribute('data-open');
        if (attr === 'true') {
            isOpenChat.setAttribute("data-open", 'false')
        }
    });

    handleOpeningChat = parameter => this.setState({
        openingChat: parameter,
        visibleChat: false,
        autoplayMainIcon: false,
        oldCounterHistoryMessage: 0,
        countMess: this.props.history.data && this.props.history.data.length
    });

    handlerHeaderCloseChat = () => this.setState({
        visibleChat: false,
        openingChat: false,
        autoplayMainIcon: true,
        countMess: this.props.history.data && this.props.history.data.length
    }, () => {
        let isOpenChat = document.getElementById('open_webchat');
        let attr = isOpenChat.getAttribute('data-open');
        if (attr === 'true') {
            isOpenChat.setAttribute("data-open", 'false')
        }
    });

    handlerMutationObserverOpenChat = () => this.setState({
        openingChat: true,
        autoplayMainIcon: false,
        countMess: this.props.history.data && this.props.history.data.length
    });

    handlerVisiblePreview = onVisiblePreviewFile => this.setState({onVisiblePreviewFile});

    handleChangeFile = (e, input) => {
        let formdata = new FormData();

        formdata.append('file', e.target.files[0]);

        this.setState({
            previewFile: formdata,
            previewFileName: e.target.files[0].name,
        }, () => {
            this.setState({
                onVisiblePreviewFile: true
            });
            input.value = null;
        });
    };

    handleChangeFontSize = fontSize => this.setState({fontSize, visibleEmojiBlock: false});

    handleShowEmoji = visible => this.setState({visibleEmojiBlock: visible});

    handlerMuteNotification = () => this.setState({muteNotification: !this.state.muteNotification});

    handlerSendFile = () => this.setState({
        previewFile: false,
        visibleDropZone: false,
        onVisiblePreviewFile: false,
        previewFileName: false
    });

    isConnectedTrue = () => this.setState({isConnected: true});

    pushSessionToParentComponent = (getSession, roomExpired) =>
        this.setState({sessionParentComponent: getSession}, () => {
            this.handlerUpdateCounterHistoryMessage(roomExpired);
        })

    getChunks = chunks => {
        return chunks.map(ch => {
            const s = ch.split('=');
            return `"${s[0]}":"${s[1]}"`
        })
    }

    sendStartConversation = (lang, session) => {
        this.socket.send(`/connector/message/account/${window.ACCOUNT_ID}/session/${session}`, {}, `{"type":"START_EVENT","event":"START_CONVERSATION"}`);
        window.localStorage.setItem('chatlanguage', lang);
    }

    sendParams = (params, lang, session) => {
        if (params) {
            const chunks = params.split('&')
            this.socket.send(`/connector/account/${window.ACCOUNT_ID}/session/${session}/params`, {}, `{${this.getChunks(chunks)}}`);
            window.localStorage.setItem('chatlanguage', lang);
        }
    }

    onSendParamsAfterFinishConversation = v => this.setState({sendParamsAfterFinishConversation: v})

    socketInit = session => {
        let url = `${window.DOMAIN_NAME}/WebConnector/webSocket`;
        let socket = new SockJS(url, null, {timeout: window.WS_CONNECTION_TIMEOUT || 10000});

        this.socket = Stomp.over(socket);
        this.socket.debug = true;

        const createConnect = () => {
            this.connected = true;
            let chatLanguage = document.getElementById('chatLanguage');
            let lang = chatLanguage.getAttribute('data-language');
            let storageChatlanguage = window.localStorage.getItem('chatlanguage');
            let pos = this.props.history.data && this.props.history.data[this.props.history.data.length - 1];

            this.socket.subscribe(`/message/${session}`, message => {
                let data = JSON.parse(message.body);

                this.props.onGetEventFeedback(data.event);
                this.props.onMessage({
                    type: `${data.type}_RECEIVER`,
                    payload: data
                });

                if (data.type === 'FINISH_EVENT' && data.event === 'FINISH_CONVERSATION') {
                    this.onSendParamsAfterFinishConversation(true)
                }

                if (data.type === 'EVENT' && data.event === 'ROOM_EXPIRED') {
                    this.setState({
                        isConnected: false
                    }, () => {
                        this.socket.disconnect(function () {
                            console.log('DISCONNECT roomExpired');
                        });
                        this.connected = false;
                        this.setState({roomExpired: true, roomExpiredSendLastMessage: true});
                    });
                }

                if (this.state.muteNotification && data.type === "KEYBOARD") {
                    let audio = new Audio(Mp3);
                    audio.play();
                }

                if (this.props.config.eventFeedback === 'TYPING') {
                    if (this.state.addMark) {
                        let historyLastElement = this.props.history.data[this.props.history.data.length - 1];
                        this.props.onAddMark(historyLastElement);
                        this.changeAddMark(false)
                    }
                }

                if (data.type === "KEYBOARD" && data.buttons && data.buttons.length) {
                    this.props.onMenuReceiver(data);
                } else {
                    if (data.type !== "EVENT") {
                        this.props.onMenuReceiverHide(data);
                        this.handleChangeHeightWithMenu('');
                    }
                }
            });

            const chatParams = document.getElementById('chatParams');
            let params = chatParams.getAttribute('data-params');
            this.sendParams(params, lang, session);

            if (this.state.roomExpiredSendingLastMessage) {
                let historyLastElement = this.props.history.data && this.props.history.data.length > 0 && this.props.history.data[this.props.history.data.length - 1];

                if (historyLastElement) {
                    this.socket.send(`/connector/message/account/${window.ACCOUNT_ID}/session/${session}`, {}, `{"type":"TEXT","text":"${historyLastElement.sender.text}"}`);
                }
            }

            if (this.props.history.data && this.props.history.data.length === 0) {
                this.sendStartConversation(lang, session);
            } else if (storageChatlanguage !== lang) {
                this.sendStartConversation(lang, session);
            } else if (pos && pos.receiver && pos.receiver.type && pos.receiver.type === "FINISH_EVENT") {
                this.sendStartConversation(lang, session);
            }

            this.isConnectedTrue();
        };

        this.socket.connect({}, () => {
            createConnect();
        }, (disconnect) => {
            if (disconnect) {
                this.setState({
                    isConnected: false
                }, () => {
                    let timerId = setInterval(function () {
                    }, 1500);
                    let socketInTimeout = this.socket;
                    let connectedInTimeout = this.connected;
                    let socketInitInTimeout = this.socketInit;

                    setTimeout(function () {
                        socketInTimeout.disconnect(function () {
                            console.log('DISCONNECT', disconnect);
                        });
                        connectedInTimeout = false;
                        socketInitInTimeout(session);

                        clearInterval(timerId);
                    }, 3000);
                });
            }
        });
    };

    handlerOnBackupHistoryMessage = () => this.props.onBackupHistoryMessages().then(() => {
        this.handlerChangeRoomExpired(false);
        this.setState({roomExpiredSendingLastMessage: true})
    });

    setChatDataParams = (prevParams, chatParams, name, value) => {
        const arrOfParams = prevParams.split('&');
        const newParams = arrOfParams.map(p => {
            if (p.indexOf(name) !== -1) {
                return `${name}=${value}`
            } else {
                return p
            }
        });

        return chatParams.setAttribute("data-params", newParams.filter(f => f).join('&'))
    }

    setInputQuery(e) {
        const {name, value} = e.target;
        let chatParams = document.getElementById('chatParams');
        const prevParams = chatParams.getAttribute('data-params');

        if (prevParams && prevParams.indexOf(name) !== -1) {
            this.setChatDataParams(prevParams, chatParams, name, value)
        } else {
            if (prevParams) {
                chatParams.setAttribute("data-params", prevParams + `&${name}=` + value)
            } else {
                chatParams.setAttribute("data-params", prevParams + `${name}=` + value)
            }

        }
    }

    onSetParams(socket, sessionParentComponent, nSendParams) {
        let chatParams = document.getElementById('chatParams');
        let language = document.getElementById('chatLanguage');
        let lang = language.getAttribute('data-language');

        if (socket && sessionParentComponent) {
            socket.send(`/connector/message/account/${window.ACCOUNT_ID}/session/${sessionParentComponent}`, {}, `{"type":"TEXT","text":"/stop"}`);
            let newParams = chatParams.getAttribute('data-params');
            nSendParams(newParams, lang, sessionParentComponent)
        }
    }

    handlerChangeVisibleWebChat = m => this.setState({visibleWebChat: m});

    render() {
        console.log('Smiddle Chat: 24.01.2024');

        const config = {attributeOldValue: true, attributes: true}
        const openWebchat = document.getElementById('open_webchat');
        let mutationObserver = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                if (mutation.attributeName === "data-open" && mutation.oldValue === 'false') {
                    mutationObserver.disconnect();
                    this.handlerMutationObserverOpenChat();
                }
            });
        });
        mutationObserver.observe(openWebchat, config);

        const webChatMutationAttr = document.getElementById('webChatMutationAttr');
        let mutationObserverVisibleWebChat = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                if (mutation.attributeName === "data-visible-attr") {
                    mutationObserverVisibleWebChat.disconnect();
                    this.handlerChangeVisibleWebChat(mutation.target.attributes["data-visible-attr"].value)
                }
            });
        });
        mutationObserverVisibleWebChat.observe(webChatMutationAttr, config);

        return (
            <div
                className={`App ${this.props.isOpen ? "show" : "hide"} ${this.state.mobilePhone ? 'use-mobile' : ''} ${this.state.largeTabletDevice ? 'tablet-large' : ''}`}
                style={{display: this.state.visibleWebChat === 'false' ? 'none' : 'block'}}
            >
                {!this.state.visibleChat && <ChatMainIcon
                    handleVisibleChat={this.handleVisibleChat}
                    visibleCounterNewMessage={this.state.visibleCounterNewMessage}
                    oldCounterHistoryMessage={this.state.oldCounterHistoryMessage}
                    autoplayMainIcon={this.state.autoplayMainIcon}
                    openingChat={this.state.openingChat}
                    handleOpeningChat={this.handleOpeningChat}
                />}

                {window.QUERY_PARAMS && <div>
                    <form>
                        <div><b>clientID: </b><input onChange={e => this.setInputQuery(e)} name="clientID"/></div>
                        <div><b>clientName: </b><input onChange={e => this.setInputQuery(e)} name="clientName"/></div>
                        <div><b>clientSurname: </b><input onChange={e => this.setInputQuery(e)} name="clientSurname"/>
                        </div>
                        <div><b>clientPhone: </b><input onChange={e => this.setInputQuery(e)} name="clientPhone"/></div>
                        <div><b>language: </b><input onChange={e => this.setInputQuery(e)} name="lng"/> (ukr,
                            ua, eng,
                            en, rus, ru)
                        </div>
                    </form>
                </div>}

                <MessengerOptions
                    visibleChat={this.state.visibleChat}
                    handleOpeningChat={this.handleOpeningChat}
                    handleVisibleChat={this.handleVisibleChat}
                    visibleCounterNewMessage={this.state.visibleCounterNewMessage}
                    oldCounterHistoryMessage={this.state.oldCounterHistoryMessage}
                    onSetParams={this.onSetParams}
                    socketParams={this.socket}
                    sessionParentComponentParams={this.state.sessionParentComponent}
                    sendParams={this.sendParams}
                />

                <div id="Chat">
                    {this.state.openingChat && <Container
                        locale={Localization()}
                        handleVisibleChat={this.handleVisibleChat}
                        handlerMuteNotification={this.handlerMuteNotification}
                        muteNotification={this.state.muteNotification}
                        fontSize={this.state.fontSize}
                        handleShowEmoji={this.handleShowEmoji}
                        visibleDropZone={this.state.visibleDropZone}
                        previewFile={this.state.previewFile}
                        handleChangeFile={this.handleChangeFile}
                        handleChangeFontSize={this.handleChangeFontSize}
                        previewFileName={this.state.previewFileName}
                        visibleEmojiBlock={this.state.visibleEmojiBlock}
                        handlerSendFile={this.handlerSendFile}
                        handlerVisiblePreview={this.handlerVisiblePreview}
                        onVisiblePreviewFile={this.state.onVisiblePreviewFile}
                        isMenuReceiver={this.props.isMenuReceiver}
                        handleChangeHeightWithMenu={this.handleChangeHeightWithMenu}
                        heightMenu={this.state.heightMenu}
                        changeAddMark={this.changeAddMark}
                        isConnected={this.state.isConnected}
                        isConnectedTrue={this.isConnectedTrue}
                        pushSessionToParentComponent={this.pushSessionToParentComponent}
                        sessionParentComponent={this.state.sessionParentComponent}
                        socketInit={this.socketInit}
                        socket={this.socket}
                        addMark={this.state.addMark}
                        notSupportedBrowser={this.notSupportedBrowser}
                        mobilePhone={this.state.mobilePhone}
                        handlerHeaderCloseChat={this.handlerHeaderCloseChat}
                        roomExpired={this.state.roomExpired}
                        handlerChangeRoomExpired={this.handlerChangeRoomExpired}
                        handlerUpdateCounterHistoryMessage={this.handlerUpdateCounterHistoryMessage}
                        sendParamsAfterFinishConversation={this.state.sendParamsAfterFinishConversation}
                        onSendParamsAfterFinishConversation={this.onSendParamsAfterFinishConversation}
                        sendParams={this.sendParams}
                    />}
                </div>
            </div>
        );
    }
}

const Localization = () => {
    let chatLanguage = document.getElementById('chatLanguage');
    let lang = chatLanguage.getAttribute('data-language');

    switch (lang.toLowerCase()) {
        case 'ru':
        case 'rus':
            return Locale.Locale.ru;
        case 'en':
        case 'eng':
            return Locale.Locale.en;
        case 'uz':
        case 'uzb':
            return Locale.Locale.uz;
        case 'uk':
        case 'ukr':
        case 'ua':
            return Locale.Locale.ua;
        default :
            return Locale.Locale.ru
    }
};

const mapStateToProps = state => ({
    isOpen: state.config.isOpen,
    history: state.history,
    config: state.config,
    isMenuReceiver: state.config.isMenu,
});

const mapDispatchers = {
    onToggleWidget,
    onGetEventFeedback,
    onMessage,
    onAddMark,
    onMenuReceiver,
    onMenuReceiverHide,
    onBackupHistoryMessages,
    onSend,
};

export default connect(mapStateToProps, mapDispatchers)(App);



// WEBPACK FOOTER //
// ./src/App.js